/*
 * @Author: your name
 * @Date: 2020-09-11 10:54:03
 * @LastEditTime: 2020-10-23 14:17:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lzxy-homepage\src\pages\home\models\InformationNews.ts
 */
export class News {
  id: number
  title: string
  date: string
  poster: string
  abstracts: string
  desc: string
  constructor (
    id: number,
    title: string,
    date: string,
    poster: string,
    abstracts: string,
    desc: string
  ) {
    this.id = id
    this.title = title
    this.date = date
    this.poster = poster
    this.abstracts = abstracts
    this.desc = desc
  }
}

export class NewsResponse {
  newsList: News[]
  total: number
  constructor (
    news: News[],
    total: number
  ) {
    this.newsList = news
    this.total = total
  }
}
